import { useState } from 'react';
import { CopyIcon, CheckIcon, Button, Tooltip } from '@forge/common';

type CopyToClipboardProps = {
  text: string;
};

export default function CopyToClipboard(props: Readonly<CopyToClipboardProps>) {
  const { text } = props;

  const [tooltipContent, setTooltipContent] = useState<
    'Copy to clipboard' | 'Copied!'
  >('Copy to clipboard');

  function copyToClipboard() {
    navigator.clipboard.writeText(text);

    setTooltipContent('Copied!');

    setTimeout(() => {
      setTooltipContent('Copy to clipboard');
    }, 2000);
  }

  return (
    <Tooltip
      position="top"
      content={tooltipContent}
    >
      <Button
        data-testid="copy-to-clip-button"
        aria-label="copy-icon"
        icon={
          tooltipContent === 'Copy to clipboard' ? <CopyIcon /> : <CheckIcon />
        }
        variant="quiet-primary"
        onClick={copyToClipboard}
      />
    </Tooltip>
  );
}
